import {
  ATTACK_HEALTH_REQUEST,
  ATTACK_HEALTH_SUCCESS,
  ATTACK_HEALTH_FAIL,
  ATTACK_RECENT_ALERTS_REQUEST,
  ATTACK_RECENT_ALERTS_SUCCESS,
  ATTACK_RECENT_ALERTS_FAIL,
  ATTACK_ENRICH_REQUEST,
  ATTACK_ENRICH_SUCCESS,
  ATTACK_ENRICH_FAIL,
  ATTACK_MAP_TECHNIQUE_REQUEST,
  ATTACK_MAP_TECHNIQUE_SUCCESS,
  ATTACK_MAP_TECHNIQUE_FAIL,
  ATTACK_CO_OCCURRENCES_REQUEST,
  ATTACK_CO_OCCURRENCES_SUCCESS,
  ATTACK_CO_OCCURRENCES_FAIL,
  ATTACK_TECHNIQUES_REQUEST,
  ATTACK_TECHNIQUES_SUCCESS,
  ATTACK_TECHNIQUES_FAIL,
  ATTACK_DECIDER_URL_REQUEST,
  ATTACK_DECIDER_URL_SUCCESS,
  ATTACK_DECIDER_URL_FAIL
} from '../actions/attackActions';

// Health Check Reducer
export const attackHealthReducer = (state = { connected: false }, action) => {
  switch (action.type) {
    case ATTACK_HEALTH_REQUEST:
      return { loading: true, connected: false };
    case ATTACK_HEALTH_SUCCESS:
      return {
        loading: false,
        connected: action.payload.connected,
        url: action.payload.url,
        version: action.payload.version,
        availableVersions: action.payload.available_versions
      };
    case ATTACK_HEALTH_FAIL:
      return { loading: false, connected: false, error: action.payload };
    default:
      return state;
  }
};

// Recent Alerts Reducer
export const attackRecentAlertsReducer = (state = { alerts: [] }, action) => {
  switch (action.type) {
    case ATTACK_RECENT_ALERTS_REQUEST:
      return { loading: true, alerts: [] };
    case ATTACK_RECENT_ALERTS_SUCCESS:
      return {
        loading: false,
        alerts: action.payload.alerts || []
      };
    case ATTACK_RECENT_ALERTS_FAIL:
      return { loading: false, alerts: [], error: action.payload };
    default:
      return state;
  }
};

// Enrich Alert Reducer
export const attackEnrichReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTACK_ENRICH_REQUEST:
      return { loading: true };
    case ATTACK_ENRICH_SUCCESS:
      return {
        loading: false,
        alertId: action.payload.alert_id,
        suggestions: action.payload.suggestions || []
      };
    case ATTACK_ENRICH_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Map Technique Reducer
export const attackMapTechniqueReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTACK_MAP_TECHNIQUE_REQUEST:
      return { loading: true };
    case ATTACK_MAP_TECHNIQUE_SUCCESS:
      return {
        loading: false,
        success: true,
        mapping: action.payload.mapping
      };
    case ATTACK_MAP_TECHNIQUE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Co-occurrences Reducer
export const attackCoOccurrencesReducer = (state = { relatedTechniques: [] }, action) => {
  switch (action.type) {
    case ATTACK_CO_OCCURRENCES_REQUEST:
      return { loading: true, relatedTechniques: [] };
    case ATTACK_CO_OCCURRENCES_SUCCESS:
      return {
        loading: false,
        techniqueIds: action.payload.technique_ids,
        relatedTechniques: action.payload.related_techniques || []
      };
    case ATTACK_CO_OCCURRENCES_FAIL:
      return { loading: false, relatedTechniques: [], error: action.payload };
    default:
      return state;
  }
};

// Techniques/Patterns Reducer
export const attackTechniquesReducer = (state = { patterns: [] }, action) => {
  switch (action.type) {
    case ATTACK_TECHNIQUES_REQUEST:
      return { loading: true, patterns: [] };
    case ATTACK_TECHNIQUES_SUCCESS:
      return {
        loading: false,
        patterns: action.payload.patterns || []
      };
    case ATTACK_TECHNIQUES_FAIL:
      return { loading: false, patterns: [], error: action.payload };
    default:
      return state;
  }
};

// Decider URL Reducer
export const attackDeciderUrlReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTACK_DECIDER_URL_REQUEST:
      return { loading: true };
    case ATTACK_DECIDER_URL_SUCCESS:
      return {
        loading: false,
        url: action.payload.url
      };
    case ATTACK_DECIDER_URL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

